import React from 'react';
import cx from 'classnames';

import { TruckIcon } from '../../SvgIconsV3/Truck';

import styles from './shippingBanner.module.less';

export const ShippingBanner = ({ className }: { className?: string }) => {
  return (
    <div className={cx(styles.shippingBanner, className)}>
      <TruckIcon title="Delivery Truck" height={20} width={20} />
      <p>We offer free shipping every day!</p>
    </div>
  );
};
